import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isExternal =
      /^https?:\/\//i.test(req.url) &&
      !req.url.includes("api.startupinspire.com");

    const skipAuth = isExternal || req.url.includes("/domain_rating/");

    if (!skipAuth && this.authService.isLoggedIn()) {
      const authToken = this.authService.getAuthorizationToken();
      req = req.clone({
        setHeaders: { Authorization: authToken },
      });
    }

    return next.handle(req);
  }
}
